import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';
import { LeaderboardResponse } from '../models/leaderboard.models';

@Injectable({ providedIn: 'root' })
export class LeaderboardService {
  constructor(private http: HttpClient) {}

  getLeaderboard(daysBack = 30): Observable<LeaderboardResponse> {
    const params = new HttpParams().set('daysBack', daysBack.toString());
    return this.http.get<LeaderboardResponse>(
      `${environment.baseURl}/api/income-leaderboard`,
      { params }
    );
  }
}
